import { Link } from 'react-router-dom';
import { replays } from '@/mocks/replays';
import SectionHeading from '@/components/feature/SectionHeading';
import ReplayCard from '@/components/feature/ReplayCard';

export default function ReplaySection() {
  const latest = replays.slice(0, 4);

  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="container-page">
        <SectionHeading
          eyebrow="直播回放精选"
          title="错过的场次，回放列表随时补课"
          desc="按日期与分类整理的回放清单，标注时长和播放量，挑重点看更省时间。"
          action={
            <Link
              to="/replay"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              全部回放
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </span>
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {latest.map((item) => (
            <ReplayCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}